import { render, staticRenderFns } from "./Academy.vue?vue&type=template&id=02c443b6&"
import script from "./Academy.vue?vue&type=script&lang=js&"
export * from "./Academy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3401916001/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02c443b6')) {
      api.createRecord('02c443b6', component.options)
    } else {
      api.reload('02c443b6', component.options)
    }
    module.hot.accept("./Academy.vue?vue&type=template&id=02c443b6&", function () {
      api.rerender('02c443b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/icons/Academy.vue"
export default component.exports